/**
 * Official list of U.S. law schools (2026).
 *
 * Shared across apps — sourced from OARM's "List of Law Schools 2026". Closed
 * schools have been removed and editorial annotations stripped. Kept as a
 * plain module (not JSON) so it participates cleanly in the library build and
 * can be tree-shaken/typed without `resolveJsonModule` in every consumer.
 *
 * The "not listed" / "Other" choice is intentionally NOT part of this array —
 * it is a UI sentinel prepended at render time (see {@link US_LAW_SCHOOL_NOT_LISTED}).
 */
export const US_LAW_SCHOOLS: readonly string[] = [
	'Albany Law School',
	'American University Washington College of Law',
	'Appalachian School of Law',
	"Atlanta's John Marshall Law School",
	'Ave Maria School of Law',
	'Barry University Dwayne O. Andreas School of Law',
	'Baylor University School of Law',
	'Belmont University College of Law',
	'Benjamin N. Cardozo School of Law at Yeshiva University',
	'Birmingham School of Law',
	'Boston College Law School',
	'Boston University School of Law',
	'Brigham Young University J. Reuben Clark Law School',
	'Brooklyn Law School',
	'California Western School of Law',
	'Campbell University Norman Adrian Wiggins School of Law',
	'Capital University Law School',
	'Case Western Reserve University School of Law',
	'Chapman University Dale E. Fowler School of Law',
	'Charleston School of Law',
	'Chicago-Kent College of Law at Illinois Tech',
	'City University of New York School of Law',
	'Cleveland State University College of Law',
	'Columbia Law School',
	'Cooley Law School',
	'Cornell Law School',
	'Creighton University School of Law',
	'DePaul University College of Law',
	'Drake Law School',
	'Drexel University Thomas R. Kline School of Law',
	'Duke University School of Law',
	'Duquesne University School of Law Thomas R. Kline School of Law',
	'Elon University School of Law',
	'Emory University School of Law',
	'Faulkner University Thomas Goode Jones School of Law',
	'Florida A & M University College of Law',
	'Florida International University College of Law',
	'Florida State University College of Law',
	'Fordham Law School',
	'George Mason University Antonin Scalia Law School',
	'George Washington University Law School',
	'Georgetown University Law Center',
	'Georgia State University College of Law',
	'Glendale University College of Law',
	'Golden Gate University School of Law',
	'Gonzaga University School of Law',
	'Harvard Law School',
	'Hofstra University Maurice A. Deane School of Law',
	'Howard University School of Law',
	'Indiana University Maurer School of Law',
	'Indiana University Robert H. McKinney School of Law',
	'Inter American University of Puerto Rico School of Law',
	'Jacksonville University College of Law',
	'Lewis and Clark Law School',
	'Liberty University School of Law',
	'Lincoln Law School of San Jose',
	'Lincoln Memorial University Duncan School of Law',
	'Louisiana State University Paul M. Hebert Law Center',
	'Loyola Marymount University Loyola Law School - Los Angeles',
	'Loyola University Chicago School of Law',
	'Loyola University New Orleans College of Law',
	'Marquette University Law School',
	'Massachusetts School of Law',
	'Mercer University School of Law',
	'Michigan State University College of Law',
	'Mississippi College School of Law',
	'Mitchell Hamline School of Law',
	'Nashville School of Law',
	'New England Law Boston',
	'New York Law School',
	'New York University School of Law',
	'North Carolina Central University School of Law',
	'Northeastern University School of Law',
	'Northern Illinois University College of Law',
	'Northern Kentucky University Salmon P. Chase College of Law',
	'Northwestern University Pritzker School of Law',
	'Nova Southeastern University Shepard Broad College of Law',
	'Ohio Northern University Pettit College of Law',
	'Oklahoma City University School of Law',
	'Pace University Elisabeth Haub School of Law',
	'Penn State Dickinson Law',
	'Penn State Law - University Park',
	'Pepperdine University Caruso School of Law',
	'Pontifical Catholic University of Puerto Rico',
	'Quinnipiac University School of Law',
	'Regent University School of Law',
	'Roger Williams University School of Law',
	'Rutgers Law School',
	'Saint Louis University School of Law',
	'Samford University Cumberland School of Law',
	'San Joaquin College of Law',
	"Sandra Day O'Connor College of Law at Arizona State University",
	'Santa Clara University School of Law',
	'Seattle University School of Law',
	'Seton Hall University School of Law',
	'South Texas College of Law Houston',
	'Southern Illinois University School of Law',
	'Southern Methodist University Dedman School of Law',
	'Southern University Law Center',
	'Southwestern Law School',
	"St. John's University School of Law",
	"St. Mary's University School of Law",
	'St. Thomas University College of Law (FL)',
	'Stanford Law School',
	'State University of New York University at Buffalo School of Law',
	'Stetson University College of Law',
	'Suffolk University Law School',
	'Syracuse University College of Law',
	'Temple University Beasley School of Law',
	'Texas A&M University School of Law',
	'Texas Southern University Thurgood Marshall School of Law',
	'Texas Tech University School of Law',
	'The Catholic University of America Columbus School of Law',
	'The Ohio State University Moritz College of Law',
	'The University of Akron School of Law',
	'The University of Memphis Cecil C. Humphreys School of Law',
	'The University of Mississippi School of Law',
	'The University of Texas at Austin School of Law',
	'The University of Toledo College of Law',
	'The University of Tulsa College of Law',
	'Thomas Jefferson School of Law',
	'Touro University Jacob D. Fuchsberg Law Center',
	'Trinity Law School Trinity International University',
	'Tufts University, Fletcher School of Law & Diplomacy',
	'Tulane University Law School',
	'UCLA School of Law',
	'University of Alabama School of Law',
	'University of Arizona James E. Rogers College of Law',
	'University of Arkansas at Little Rock William H. Bowen School of Law',
	'University of Arkansas School of Law',
	'University of Baltimore School of Law',
	'University of California Berkeley School of Law',
	'University of California College of the Law, San Francisco',
	'University of California Davis School of Law',
	'University of California Irvine School of Law',
	'University of Chicago Law School',
	'University of Cincinnati College of Law',
	'University of Colorado Law School',
	'University of Connecticut School of Law',
	'University of Dayton School of Law',
	'University of Denver Sturm College of Law',
	'University of Detroit Mercy School of Law',
	'University of Florida Fredric G. Levin College of Law',
	'University of Georgia School of Law',
	"University of Hawai'i at Manoa William S. Richardson School of Law",
	'University of Houston Law Center',
	'University of Idaho College of Law',
	'University of Illinois Chicago School of Law',
	'University of Illinois College of Law',
	'University of Iowa College of Law',
	'University of Kansas School of Law',
	'University of Kentucky J. David Rosenberg College of Law',
	'University of La Verne College of Law',
	'University of Louisville Louis D. Brandeis School of Law',
	'University of Maine School of Law',
	'University of Maryland Francis King Carey School of Law',
	'University of Massachusetts School of Law',
	'University of Miami School of Law',
	'University of Michigan Law School',
	'University of Minnesota Law School',
	'University of Missouri School of Law',
	'University of Missouri-Kansas City School of Law',
	'University of Montana Alexander Blewett III School of Law',
	'University of Nebraska College of Law',
	'University of Nevada Las Vegas William S. Boyd School of Law',
	'University of New Hampshire Franklin Pierce School of Law',
	'University of New Mexico School of Law',
	'University of North Carolina School of Law',
	'University of North Dakota School of Law',
	'University of North Texas at Dallas College of Law',
	'University of Notre Dame Law School',
	'University of Oklahoma College of Law',
	'University of Oregon School of Law',
	'University of Pennsylvania Carey Law School',
	'University of Pittsburgh School of Law',
	'University of Puerto Rico School of Law',
	'University of Richmond School of Law',
	'University of San Diego School of Law',
	'University of San Francisco School of Law',
	'University of South Carolina Joseph F. Rice School of Law',
	'University of South Dakota Knudson School of Law',
	'University of Southern California Gould School of Law',
	'University of St. Thomas School of Law (MN)',
	'University of Tennessee College of Law',
	'University of the District of Columbia David A. Clarke School of Law',
	'University of the Pacific McGeorge School of Law',
	'University of Utah S.J. Quinney College of Law',
	'University of Virginia School of Law',
	'University of Washington School of Law',
	'University of Wisconsin Law School',
	'University of Wyoming College of Law',
	'Vanderbilt University Law School',
	'Vermont Law and Graduate School',
	'Villanova University Charles Widger School of Law',
	'Wake Forest University School of Law',
	'Washburn University School of Law',
	'Washington and Lee University School of Law',
	'Washington University in St. Louis School of Law',
	'Wayne State University Law School',
	'West Virginia University College of Law',
	'Western New England University School of Law',
	'Western State College of Law at Westcliff University',
	'Widener University Commonwealth Law School',
	'Widener University Delaware Law School',
	'Willamette University College of Law',
	'William & Mary Law School',
	'Wilmington University School of Law',
	'Yale Law School',
];

/**
 * Sentinel selected when an applicant's U.S. law school is absent from the
 * dropdown. Rendered at the TOP of the list; selecting it reveals the manual
 * name/city/state entry fields.
 */
export const US_LAW_SCHOOL_NOT_LISTED = 'Law School Not Listed' as const;
